import { graphql } from '@/gql';
import type { TipDriverMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const tipDriver = async ({ tipAmount, requestId, notes }: TipDriverMutationVariables) => {
  const response = await mutationExecute({
    variables: {
      tipAmount,
      requestId,
      notes,
    },
    mutation: graphql(`
      mutation TipDriver($tipAmount: Float!, $requestId: String!, $notes: String!) {
        tipDriver(tipAmount: $tipAmount, requestId: $requestId, notes: $notes) {
          id
        }
      }
    `),
  });

  return response.data?.tipDriver;
};
